import { StepConfig } from 'components/new-ui/composed/multistep-form/types';
import { CreateManifestJobFormFields, CreateManifestJobFormSteps } from './types';
import {
    assignAgentSectionValidationSchema,
    customerSectionValidationSchema,
    getDeliveryTermsSectionValidationSchema,
    jobSectionValidationSchema,
} from 'views/jobs/validationSchemas';
import JobSection from 'views/jobs/components/create-job/JobSection';
import CustomerSection from 'views/jobs/components/create-job/CustomerSection';
import DeliveryTermsSection from 'views/jobs/components/create-job/DeliveryTermsSection';
import AssignAgentSection from './AssignAgentSection';

export const getStepsConfig = ({
    canAssignJobs,
}: {
    canAssignJobs?: boolean;
}): StepConfig<CreateManifestJobFormFields>[] => {
    const steps: StepConfig<CreateManifestJobFormFields>[] = [
        {
            key: CreateManifestJobFormSteps.JOB,
            label: 'Job',
            validationSchema: jobSectionValidationSchema,
            component: JobSection,
            skipAutoProgress: true,
        },
        {
            key: CreateManifestJobFormSteps.CUSTOMER,
            label: 'Customer',
            validationSchema: customerSectionValidationSchema,
            component: CustomerSection,
        },
        {
            key: CreateManifestJobFormSteps.DELIVERY_TERMS,
            label: 'Delivery Terms',
            validationSchema: getDeliveryTermsSectionValidationSchema(true),
            component: DeliveryTermsSection,
        },
    ];

    if (canAssignJobs) {
        steps.push({
            optional: true,
            key: CreateManifestJobFormSteps.ASSIGN_AGENT,
            label: 'Assign Agent',
            validationSchema: assignAgentSectionValidationSchema,
            component: AssignAgentSection,
        });
    }

    return steps;
};
